import { Molecule, wrap } from 'AppReact';
import styled, { css } from 'styled-components';
import { Popup, SecondaryTextSm } from 'atoms';
import { UnderlineDecoration, Mr2 } from 'wrappers';

const template = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    position: relative;
    color: ${theme?.colour?.secondary}
    font-size: 12px;
    line-height: 14px;
    margin-top: 8px;
    margin-right: 20px;

    span {
      display: none;
    }

    &:hover {
      span {
        display: unset;
      }
    }
  `}
`;

export default Molecule({
  template,
  atoms: [
    {
      component: wrap(SecondaryTextSm, Mr2),
      name: 'Property',
      displayValue: ({ properties }) => properties[0] ?? '',
    },
    {
      component: wrap(SecondaryTextSm, UnderlineDecoration),
      name: 'More',
      renderIf: ({ properties }) => properties.length > 1,
      displayValue: ({ properties }) => `and ${properties.length - 1} other`,
    },
    {
      component: Popup,
      name: 'Popup',
      renderIf: ({ properties }) => properties.length > 1,
      displayValue: ({ properties }) => properties.join(', ')
    }
  ],
})